import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TPrintLabelsTableItem } from './types';

export const tableStructure: TTableStructure<keyof TPrintLabelsTableItem, TPrintLabelsTableItem>[] =
	[
		{
			selector: 'rowNumber',
			name: '#',
			show: true,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.RIGHT,
			colSpan: 1,
		},
		{
			selector: 'omnivaTrackingNumber',
			name: 'Omniva S10',
			show: true,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
			colSpan: 1,
		},
		{
			selector: 'firstMileTrackingNumber',
			name: 'First mile S10',
			show: true,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
			colSpan: 1,
		},
		{
			selector: 'deliveryCountryName',
			name: 'Destination country',
			show: true,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
			colSpan: 1,
		},
		{
			selector: 'totalWeightInKg',
			name: 'Weight, kg',
			show: true,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.RIGHT,
			colSpan: 1,
		},
		{
			selector: 'emFullName',
			name: 'EM',
			show: true,
			type: ETableStructureType.STRING,
			align: ETableStructureAlign.LEFT,
			colSpan: 1,
		},
		{
			selector: 'actions',
			name: 'Actions',
			show: true,
			type: ETableStructureType.BUTTONS,
			align: ETableStructureAlign.LEFT,
			colSpan: 1,
		},
	];
